// Firebase initializer for Analytics (modular SDK)
// Replace the firebaseConfig values below with your project's config from the Firebase console.
// Requires the `firebase` package (installed already).

import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as fbLogEvent } from 'firebase/analytics';

let analyticsInstance = null;

export function initFirebaseAnalytics(config = null) {
    try {
        const firebaseConfig = {
            apiKey: "AIzaSyA9m2t7t_jgQxKrIhw0A6z209cIxxOVTZc",
            authDomain: "typedude-f1a88.firebaseapp.com",
            projectId: "typedude-f1a88",
            storageBucket: "typedude-f1a88.firebasestorage.app",
            messagingSenderId: "1053064817523",
            appId: "1:1053064817523:web:a671eb19f3e58c61073306",
            measurementId: "G-E95G0H0Z3R"
        };

        const app = initializeApp(firebaseConfig);
        analyticsInstance = getAnalytics(app);

        // Expose a simple global wrapper for backwards compatibility with analytics.js
        window.firebaseLogEvent = (eventName, params = {}) => {
            try {
                fbLogEvent(analyticsInstance, eventName, params);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.debug('[firebase] logEvent failed', err);
            }
        };

        // eslint-disable-next-line no-console
        console.debug('[firebase] analytics initialized');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.debug('[firebase] analytics init failed (check config)', err);
    }
}

// Auto-init on import using placeholder config.
// Replace the values above in-place or call initFirebaseAnalytics(customConfig) from your runtime.
initFirebaseAnalytics();
